import * as React from "react";

function SvgPerkville(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...{ ...props, ref }}
    >
      <defs>
        <path
          d="M22.43 222.27H0V1.487h58.652c37.799 0 49.332 3.802 61.812 10.793 20.82 11.44 32.068 31.78 32.068 57.185 0 29.23-14.116 52.73-38.439 64.164-10.293 4.777-19.882 7.332-44.56 7.332H44.86v81.309H22.43zM73.387 37.374H44.86v67.366h23.386c18.271 0 23.7-2.25 29.81-11.468 3.817-6 5.435-12.368 5.435-22.838 0-20.699-11.23-33.06-30.106-33.06z"
          id="Perkville_svg__a"
        />
        <path
          d="M101.957 66.98c0-12.02-1.305-18.35-5.283-24.333-4.277-6.364-10.53-9.497-19.456-9.497-16.819 0-26.373 12.647-26.373 35.118v.61h51.112V66.98zM50.174 99.914v1.276c0 24.983 12.909 39.246 35.629 39.246 15.203 0 29.38-5.422 42.894-16.142l17.156 25.323c-19.475 15.21-39.936 22.465-63.698 22.465-48.453 0-79.817-32.922-79.817-83.854 0-29.123 6.314-48.48 21.132-64.293C37.325 9.04 54.127 2.108 76.59 2.108c19.425 0 37.893 6.305 48.819 17.084 15.46 15.147 22.42 37.038 22.42 70.88v9.842H50.174z"
          id="Perkville_svg__c"
        />
        <path
          d="M83.985 41.182c-3.964-2.272-7.34-3.217-11.94-3.217-9.205 0-17.486 4.45-25.15 13.688v115.573H5.807V58.076c0-22.017-2.415-38.639-5.807-47.918L36.77 0c3.688 6.664 5.85 14.019 6.439 23.298C52.143 10.814 64.723 0 80.02 0c6.136 0 8.87.626 15.33 3.506L83.986 41.182z"
          id="Perkville_svg__e"
        />
        <path
          d="M44.859.737h-.012L1.342 11.255c2.54 16.91 2.886 28.103 2.886 42.45v184.207h43.195V53.705c0-21.731-.615-40.853-2.564-52.968zm58.978 237.175l-55.43-92.611L90.63 74.434h51.918l-52.539 68.34 64.78 95.138h-50.952z"
          id="Perkville_svg__g"
        />
        <path
          d="M97.407 167.406H61.839L2.162 7.89l43.932-5.397 23.76 73.094c3.548 10.812 8.348 28.507 10.585 38.985 1.287-9.541 4.794-25.018 9.92-41.227L112.51 5.327h44.911l-60.015 162.08z"
          id="Perkville_svg__i"
        />
        <path
          d="M5.82 235.3V74.722l43.958-6.665V235.3H5.819zM27.791 53.375C13.023 53.375.89 41.563.89 26.857.89 12.193 13.35.363 28.46.363c14.737 0 26.55 11.83 26.55 26.494 0 14.706-12.134 26.518-27.218 26.518z"
          id="Perkville_svg__k"
        />
        <path
          d="M46.463 241.757c-18.484 0-33.363-8.644-38.539-22.35-3.274-8.301-3.905-13.403-3.905-36.691V60.688c0-21.322-.66-34.419-2.314-49.104L46.14 1.676c1.661 8.957 2.29 19.48 2.29 42.479v127.36c0 28.094.349 31.914 2.904 36.402 1.656 2.882 5.194 4.446 8.757 4.446 1.613 0 2.59 0 4.845-.626l7.473 25.556c-7.473 2.87-16.517 4.464-25.945 4.464z"
          id="Perkville_svg__m"
        />
        <path
          d="M45.336 241.757c-18.436 0-33.322-8.644-38.515-22.35-3.28-8.301-3.905-13.403-3.905-36.691V60.688c0-21.322-.683-34.419-2.304-49.104l44.466-9.908c1.619 8.957 2.242 19.48 2.242 42.479v127.36c0 28.094.32 31.914 2.934 36.402 1.607 2.882 5.163 4.446 8.738 4.446 1.601 0 2.603 0 4.87-.626l7.467 25.556c-7.467 2.87-16.548 4.464-25.993 4.464z"
          id="Perkville_svg__o"
        />
        <path
          d="M99.841 66.98c0-12.02-1.331-18.35-5.23-24.333-4.23-6.364-10.435-9.497-19.225-9.497-16.624 0-26.054 12.647-26.054 35.118v.61h50.51V66.98zM48.676 99.914v1.276c0 24.983 12.683 39.246 35.181 39.246 15.009 0 28.974-5.422 42.344-16.142l16.949 25.323c-19.202 15.21-39.423 22.465-62.866 22.465-47.894 0-78.827-32.922-78.827-83.854 0-29.123 6.183-48.48 20.841-64.293C35.988 9.04 52.593 2.108 74.717 2.108c19.237 0 37.463 6.305 48.23 17.084 15.316 15.147 22.167 37.038 22.167 70.88v9.842H48.676z"
          id="Perkville_svg__q"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(0 15.677)">
          <mask id="Perkville_svg__b" fill="#fff">
            <use xlinkHref="#Perkville_svg__a" />
          </mask>
          <path
            fill="#ACCE35"
            mask="url(#Perkville_svg__b)"
            d="M-59.924 281.676h272.379V-57.919H-59.924z"
          />
        </g>
        <g transform="translate(155.574 67.935)">
          <mask id="Perkville_svg__d" fill="#fff">
            <use xlinkHref="#Perkville_svg__c" />
          </mask>
          <path
            fill="#ACCE35"
            mask="url(#Perkville_svg__d)"
            d="M-59.348 231.282h268.863V-57.092H-59.348z"
          />
        </g>
        <g transform="translate(316.167 67.935)">
          <mask id="Perkville_svg__f" fill="#fff">
            <use xlinkHref="#Perkville_svg__e" />
          </mask>
          <path
            fill="#ACCE35"
            mask="url(#Perkville_svg__f)"
            d="M-59.595 226.95h214.542V-59.725H-59.595z"
          />
        </g>
        <g transform="translate(419.046)">
          <mask id="Perkville_svg__h" fill="#fff">
            <use xlinkHref="#Perkville_svg__g" />
          </mask>
          <path
            fill="#ACCE35"
            mask="url(#Perkville_svg__h)"
            d="M-58.95 297.609h274.03V-58.963H-58.95z"
          />
        </g>
        <g transform="translate(564.583 70.548)">
          <mask id="Perkville_svg__j" fill="#fff">
            <use xlinkHref="#Perkville_svg__i" />
          </mask>
          <path
            fill="#ACCE35"
            mask="url(#Perkville_svg__j)"
            d="M-57.825 226.593h275.234V-56.693H-57.825z"
          />
        </g>
        <g transform="translate(725.176 2.613)">
          <mask id="Perkville_svg__l" fill="#fff">
            <use xlinkHref="#Perkville_svg__k" />
          </mask>
          <path
            fill="#ACCE35"
            mask="url(#Perkville_svg__l)"
            d="M-60.484 294.99h176.867V-59.328H-60.484z"
          />
        </g>
        <g transform="translate(797.944)">
          <mask id="Perkville_svg__n" fill="#fff">
            <use xlinkHref="#Perkville_svg__m" />
          </mask>
          <path
            fill="#ACCE35"
            mask="url(#Perkville_svg__n)"
            d="M-58.935 301.46h191.984V-58.027H-58.935z"
          />
        </g>
        <g transform="translate(868.204)">
          <mask id="Perkville_svg__p" fill="#fff">
            <use xlinkHref="#Perkville_svg__o" />
          </mask>
          <path
            fill="#ACCE35"
            mask="url(#Perkville_svg__p)"
            d="M-60.028 301.46h191.997V-58.027H-60.028z"
          />
        </g>
        <g transform="translate(938.463 67.935)">
          <mask id="Perkville_svg__r" fill="#fff">
            <use xlinkHref="#Perkville_svg__q" />
          </mask>
          <path
            fill="#ACCE35"
            mask="url(#Perkville_svg__r)"
            d="M-59.463 231.282h265.497V-57.092H-59.463z"
          />
        </g>
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgPerkville);
